( function () {
    'use strict';
    e.maps = {};
    e.maps.loadAPI = function ( strCallback ) {
        var gm = document.createElement( 'script' ),
            script = document.getElementsByTagName( 'script' )[ 0 ];
        gm.src = '//maps.google.com/maps/api/js?v=3&key=AIzaSyD5h8zgD3C2weQUgJhpOg2TzDnB3rLEins&callback=' + strCallback;
        script.parentNode.insertBefore( gm, script ); 
    };
    e.maps.init = function () {
        var jGoogleMaps = jQuery( '.e-google-map' );
        if ( jGoogleMaps.length > 0 ) {
            e.maps.loadAPI( 'e.maps.load' );
        }
    };
    e.maps.load = function () {
        var jGoogleMaps = jQuery( '.e-google-map' );
        var jSearchMarkerSettings = jQuery( '#js-e-maps-search-marker-settings' );
        if ( jGoogleMaps.length > 0 ) {
            jGoogleMaps.each( function ( index, element ) {
                var jGoogleMap = jQuery( element );
                // Save map settings on Map object
                jGoogleMap.data( 'settings', {
                    mapData: jGoogleMap.find( 'code.e-google-map-data' ),
                    mapZoom: ( jGoogleMap.data( 'zoom' ) !== undefined ? jGoogleMap.data( 'zoom' ) : 10 ),
                    mapRatio: ( jGoogleMap.data( 'ratio' ) !== undefined ? jGoogleMap.data( 'ratio' ).split( ':' ) : '' ),
                    mapColor: e.util.rgb2hex( ( jGoogleMap.data( 'color' ) !== undefined ? jGoogleMap.data( 'color' ) : jGoogleMap.css( 'color' ) ) ).replace( /^\#/, '' ),
                    mapDefaultMarkerColor: e.util.rgb2hex( ( jGoogleMap.find( 'code.e-google-map-data' ).first().css( 'color' ) !== undefined ? jGoogleMap.find( 'code.e-google-map-data' ).first().css( 'color' ) : jGoogleMap.css( 'color' ) ) ).replace( /^\#/, '' ),
                    mapSearchIconColor: ( jSearchMarkerSettings.length > 0 ? e.util.rgb2hex( jSearchMarkerSettings.css( 'color' ) ).replace( /^\#/, '' ) : '' ),
                    mapMaxZoomLevel: ( jGoogleMap.data( 'max-zoom-level' ) !== undefined ? jGoogleMap.data( 'max-zoom-level' ) : 12 ),
                    mapMinSearchRadius: ( jGoogleMap.data( 'min-search-radius' ) !== undefined ? jGoogleMap.data( 'min-search-radius' ) : 20 )
                } );
                if ( jGoogleMap.data( 'settings' ).mapRatio !== '' && jGoogleMap.data( 'settings' ).mapRatio.length === 2 ) {
                    jGoogleMap.css( 'padding-bottom', ( parseInt( jGoogleMap.data( 'settings' ).mapRatio[ 1 ] ) / parseInt( jGoogleMap.data( 'settings' ).mapRatio[ 0 ] ) * 100 ) + '%' );
                }
                var mapOptions = {
                    center: new google.maps.LatLng( 56.26392, 9.501785 ), //DK
                    scrollwheel: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    zoom: jGoogleMap.data( 'settings' ).mapZoom,
                    styles: [ {
                        stylers: [
                            //{ visibility: 'simplified' }
                        ]
                    }, {
                        featureType: 'road',
                        stylers: [ {
                            visibility: 'on'
                        }, {
                            //hue: mapColor
                        }, {
                            lightness: 10
                        }, {
                            saturation: -10
                        } ]
                    }, {
                        featureType: 'landscape',
                        stylers: [ {
                            lightness: 30
                        }, {
                            saturation: -70
                        } ]
                    }, {
                        featureType: 'water',
                        stylers: [ {
                            lightness: 50
                        }, {
                            saturation: -50
                        } ]
                    } ]
                };
                jGoogleMap.gmap( mapOptions ).bind( 'init', function () {
                    if ( jGoogleMap.is( '#js-e-map' ) === true ) {
                        jGoogleMap.gmap( 'microdata', 'http://schema.org/Organization', function ( result, item, index ) {
                            if ( jQuery( item ).is( '.js-e-map-list-item' ) === true ) {
                                e.maps.helpers.addMicroDataMarkers( result, item, index, jGoogleMap );
                            }
                        } );
                        // Init dealer search
                        e.dealersearch.init();
                    }
                    else {
                        //Add single marker
                        var addr = jQuery( jGoogleMap.data( 'settings' ).mapData ).text();
                        addr = decodeURIComponent( addr.replace( /^http:\/\//, '' ).replace( /[\(zoom,ratio=:0-9\)\s\%]+$/i, '' ) );
                        e.maps.helpers.addAddressMarker( jGoogleMap, addr );
                    }
                } );
            } );
        }
    };
    e.maps.helpers = {};
    e.maps.helpers.icon = function ( jGoogleMap, char, color ) {
        var url = '//chart.googleapis.com/chart?chst=d_map_pin_letter_withshadow&chld=';
        var character = ( char !== '' ? encodeURIComponent( char ) : '%E2%80%A2' );
        var fill_color = ( String( color ).match( /^[0-9a-f]{6}$/i ) !== null ? color : jGoogleMap.data( 'settings' ).mapColor );
        var text_color = '000000';
        return url + character + '|' + fill_color + '|' + text_color;
    };
    e.maps.helpers.addAddressMarker = function ( jGoogleMap, address ) {
        var markerColor = jGoogleMap.data( 'settings' ).mapDefaultMarkerColor;
        var gGeocoder = new google.maps.Geocoder();
        gGeocoder.geocode( {
            address: address
        }, function ( results, status ) {
            if ( status === google.maps.GeocoderStatus.OK ) {
                var latlng = results[ 0 ].geometry.location;
                //console.log( latlng );
                var gMarkerOptions = {
                    bounds: false, // Special to jQuery.ui.map
                    position: latlng,
                    icon: e.maps.helpers.icon( jGoogleMap, '', markerColor )
                };
                jGoogleMap.gmap( 'addMarker', gMarkerOptions );
                var map = jGoogleMap.gmap( 'get', 'map' );
                map.setCenter( latlng );
            }
        } );
    };
    e.maps.helpers.addMicroDataMarkers = function ( result, item, index, jGoogleMap ) {
        var jMicroDataElement = jQuery( item );
        var jMarkerData = jMicroDataElement.find( '.js-e-maps-marker-data' );
        var markerColor = e.util.rgb2hex( jMarkerData.css( 'color' ) ).replace( /^\#/, '' );
        // Parse coordinates
        var lat = parseFloat( result.geo[ 0 ].latitude );
        var lng = parseFloat( result.geo[ 0 ].longitude );
        if ( isNaN( lat ) || isNaN( lng ) || lat === 0 || lng === 0 ) {
            jGoogleMap.after( '<p> Error - lat/lng data not valid for this address: ' + result.name + ' </p>' );
            return;
        }
        if ( lat !== undefined && lng !== undefined ) {
            var latlng = new google.maps.LatLng( lat, lng );
            var gMarkerOptions = {
                bounds: true, // Special to jQuery.ui.map
                position: latlng,
                icon: e.maps.helpers.icon( jGoogleMap, '', markerColor )
            };
            var jMarker = jGoogleMap.gmap( 'addMarker', gMarkerOptions, function ( map, marker ) {
                // find correct element and map it to marker
                var jDealerElement = jQuery( item );
                // Add reference to dealer DOM element on Marker
                marker.dealer = item;
                // When clicking the dealer element, do what ever happens on marker click
                var jClickElement = jDealerElement.find( '.js-e-map-list-dealer-name' );
                jClickElement.on( 'click', function () {
                    jQuery( marker ).triggerEvent( 'click' );
                    return false;
                } );
            } );
            // Add event to Markers
            jMarker.click( function () {
                e.maps.helpers.markerClick( jGoogleMap, this );
            } );
        }
    };
    e.maps.helpers.markerClick = function ( jGoogleMap, marker ) {
        var jDealer = jQuery( marker.dealer );
        // Build content for infowindow
        var infoWindowContent = jDealer.find( '.js-e-maps-infowindow-content' ).html();
        jGoogleMap.gmap( 'openInfoWindow', {
            'content': infoWindowContent,
            maxWidth: 600
        }, marker );
        e.util.scroll.toElement( jGoogleMap, 0, true, false );
        // Hook up to dealersearch if it's defined
        if ( e.dealersearch.markerClicked !== undefined ) {
            e.dealersearch.markerClicked();
        }
    };
} )();
